<template>
  <div class="oa-button"
    :class="getMarginClass(btnClass.margin)"
  >
    <button
      class="btn"
      :class="getColorClass(btnClass.color)"
      :disabled="disabled"
      @click="clicked"
    >
      {{ text }}
    </button>
  </div>
</template>

<script>

export default {
  name: 'OaButton',
  props: {
    text: { required: true },
    disabled: {
      default: false,
    },
    btnClass: {
      default: {},
    },
    gaEvt: {
      default: () => ({})
    },
  },
  computed: {
  },
  methods: {
    clicked() {
      this.$emit('click');
    },
    getMarginClass(margin) {
      switch (margin) {
        case 'right':
          return 'ut-mr-4';
        case 'left':
          return 'ut-ml-4';
        default:
          return '';
      }
      return '';
    },
    getColorClass(color) {
      switch (color) {
        case 'green':
          return 'btn-green';
        case 'white':
          return 'btn-small white-bg';
        default:
          return '';
      }
      return '';
    },
  },
};
</script>

<style scoped lang="scss">
  .oa-button {
    display: inline-block;
  }
</style>
